import { ThemeConfig } from "antd";
import { colors } from "../colors";

export const antdThemeConfig: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
  },
  components: {
    Button: {
      defaultColor: colors.primary,
      primaryColor: colors.primary800,
      defaultBorderColor: colors.primary,
      colorPrimary: colors.primary,
      colorPrimaryHover: colors.primary,
      dangerColor: colors.errorMain,
      colorError: colors.errorBackground,
    },
    Input: {
      colorPrimary: colors.defaultGrey,
      activeShadow: colors.defaultGrey,
      activeBorderColor: colors.defaultGrey,
      colorPrimaryHover: colors.defaultGrey,
    },
    Pagination: {
      itemBg: "transparent",
    },
    Tabs: {
      colorPrimary: colors.neutral700,
      colorPrimaryHover: colors.primary700,
      colorPrimaryActive: colors.primary700,
      fontWeightStrong: 700,
      itemColor: colors.neutral700,
      itemHoverColor: colors.primary700,
      itemActiveColor: colors.primary700,
      itemSelectedColor: colors.primary700,
      inkBarColor: colors.error300,
      fontSize: 14,
    },
    Timeline: {
      colorPrimary: colors.primary700,
    },
    Steps: {
      colorPrimary: colors.primary700,
      colorText: colors.neutral700,
      colorPrimaryBorder: colors.warning300,
      fontWeightStrong: 700,
      colorInfoText: colors.primary700,
    },
    Radio: {
      colorPrimary: colors.primary700,
      colorPrimaryHover: colors.primary700,
    },
  },
};
